import ja from './ja.json';
import ar from './ar.json';
import rus from './rus.json';
import ta from './ta.json';
import tr from './tr.json';
import uk from './uk.json';
import vi from './vi.json';
import svse from './svse.json';
import eses from './eses.json';
import ro from './ro.json';
import ptbr from './ptbr.json';
import ko from './ko.json';
import it from './it.json';
import id from './id.json';
import hu from './hu.json';
import hi from './hi.json';
import el from './el.json';
import fr from './fr.json';
import de from './de.json';
import fi from './fi.json';
import fil from './fil.json';
import nl from './nl.json';
import zhtw from './zhtw.json';
import zhcn from './zhcn.json';

export default {
	'ar': { src: ar.data },
	'ru': { src: rus.data },
	'ta': { src: ta.data },
	'tr': { src: tr.data },
	'uk': { src: uk.data },
	'vi': { src: vi.data },
	'sv-SE': { src: svse.data },
	'es-ES': { src: eses.data },
	'ro': { src: ro.data},
	'pt-BR': { src: ptbr.data},
	'ko': { src: ko.data}, 
	'ja': {src: ja.data},
	'it': {src: it.data },
	'id': {src: id.data},
	'hu': {src: hu.data}, 
	'hi': {src: hi.data},
	'el': {src: el.data},
	'fr': {src: fr.data},
	'de': {src: de.data},
	'fi': {src:fi.data},
	'fil': {src:fil.data},
	'nl': {src: nl.data},
	'zh-TW': {src: zhtw.data},
	'zh-CN': {src: zhcn.data},
}
